import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

interface TimePickerProps {
  label: string;
  value: string; // HH:MM:SS format
  onChange: (value: string) => void;
  error?: boolean;
  helperText?: string;
  required?: boolean;
}

export const TimePicker: React.FC<TimePickerProps> = ({
  label,
  value,
  onChange,
  error,
  helperText,
  required = false
}) => {
  // Convert HH:MM:SS to HH:MM for display
  const displayValue = value ? value.substring(0, 5) : '';

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const timeValue = e.target.value; // HH:MM format from input
    // Convert to HH:MM:SS for storage
    onChange(timeValue ? `${timeValue}:00` : '');
  };

  return (
    <TextField
      fullWidth
      label={label}
      type="time"
      value={displayValue}
      onChange={handleChange}
      error={error}
      helperText={helperText}
      required={required}
      InputLabelProps={{ 
        shrink: true,
        sx: {
          fontWeight: 500,
          fontSize: '0.875rem'
        }
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <AccessTimeIcon sx={{ color: '#666', fontSize: '1.25rem' }} />
          </InputAdornment>
        ),
        sx: {
          '& input[type="time"]': {
            fontSize: '1rem',
            fontWeight: 400,
            cursor: 'pointer',
            '&::-webkit-calendar-picker-indicator': {
              cursor: 'pointer',
              fontSize: '1.1rem',
              padding: '4px',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
                borderRadius: '4px'
              }
            }
          }
        }
      }}
      inputProps={{
        step: 300 // 5 minute intervals
      }}
      sx={{
        '& .MuiOutlinedInput-root': {
          backgroundColor: 'white',
          '&:hover': {
            backgroundColor: '#f8f9fa'
          },
          '&.Mui-focused': {
            backgroundColor: 'white'
          }
        }
      }}
    />
  );
};

export default TimePicker;
